(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'DestinationContent',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		if ($('#destinationcontent-location-hidden').val() !== '') {
			handleSelect($('#destinationcontent-location-hidden').val(), '', '');
		}

		Adzuki.Typeahead(
			'.location-search',
			'/Fodors/search',
			function select(item) {
				var location_value = '';

				if (item.name.length > 0) {
					location_value += item.name;
				}

				$('#destinationcontent-location').val(location_value);
				$('#destinationcontent-location-hidden').val(item.name);

				handleSelect(item.id, item.lat, item.lon);
			},
		);

		$('.location-search').keydown(function enterPressed(e) {
			if (e.keyCode === 13) {
				e.preventDefault();
			}
		});

		$('.location-search').click(function locationBoxClicked() {
			$(this).val('');
		});

		$('.item').click(function itemClicked() {
			// document.location = Adzuki.base_uri + '/DestinationContents/view/' + $(this).data("id") + '/page_num:' + $(this).data("page-num");
		});

		$('.dc-submit').click(function submitButtonPressed() {
			$('.dc-submit-btn').click();
		});
	};

	function handleSelect(id, lat, lon)
	{
		var map;// eslint-disable-line no-unused-vars
		var destination_guide_id;

		if (id === 0) {
			// destination not found
			$('#destinationcontent-location').val('');
			$('#destinationcontent-location-hidden').val('');
		} else {
			// destination found
			$('.destination-details').removeClass('hidden');

			destination_guide_id = $('#destinationcontent-destination_guide_id').val();

			Adzuki.Ajax.get('/DestinationContents/view/' + id + '/' + destination_guide_id)
			.then(function populate(data) {
				$('#destination-guide-content').html(data);
				Adzuki.DestinationContent.init();

				Adzuki.Form.initAjaxForm('DestinationContentAction');
				// Adzuki.Buckets.initAddButton($('.bucket-addto'));
			});
		}
	}
}(jQuery, window.Adzuki || {}));